import type { UseModalReturn } from "@tosize/ui";
import { createContext } from "react";

export const FilterDialogContext = createContext<UseModalReturn | null>(null);
